export default "__VITE_ASSET__16ab32b7__"